import {UNSET_CURRENT_HR_DOCS} from "../../../enums/Request/request.types";

export const unsetCurrentHrDocumentAction=()=>{
    return {
        type: UNSET_CURRENT_HR_DOCS,
        payload: null,
    };
};
